// extracted by mini-css-extract-plugin
export default {"section":"Section_section__m2j6e","header":"Section_header__vZwoU","centered":"Section_centered__Nmg7j","title":"Section_title__ZPSwT","subtitle":"Section_subtitle__YL67O"};